import apiClient from '../service/api'

export const getAllAudios = async (page) => {
  const { data } = await apiClient.get(`/v1/audios?page=${page}`)
  return data
}

export const loadAudio = async (audioId) => {
  const response = await apiClient.get(`/v1/audios/${audioId}/listen`, {
    responseType: 'blob',
  })
  const audioUrl = URL.createObjectURL(response.data)
  return audioUrl
}
